import Style from './panelStyles.module.scss';
import { useNode } from '@craftjs/core';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { PanelContainer } from './uiKit/panelContainer/panelContainer';
import { hasSection } from './helpers/helper';
import { FormTextInputProps } from '../../types/TextInput';
import { ControlsGroup } from './uiKit/controlsGroup/controlsGroup';
import { SettingsInput } from './uiKit/input/settingsInput';

type TextFieldPanelSection = 'Units' | 'Placeholder' | 'Decimal';

export type TextFieldPanelProps = {
  sections: TextFieldPanelSection[];
};

export const TextFieldPanel = ({ sections }: TextFieldPanelProps) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.Panels.TextField');
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props as FormTextInputProps,
  }));

  return (
    <PanelContainer header={t('Header')} panelName={'General'}>
      {hasSection<TextFieldPanelSection>(sections, 'Placeholder') && (
        <ControlsGroup
          header={t('Placeholder')}
          collapsible={true}
          contentClassName={Style.flexContainer}
          expanded={!!props.placeholder}
          onOpen={() => {
            setProp((prop: FormTextInputProps) => {
              prop.placeholder = t('Placeholder');
            }, 500);
          }}
          onClose={() => {
            setProp((prop: FormTextInputProps) => {
              prop.placeholder = undefined;
            }, 500);
          }}
        >
          <SettingsInput
            placeholder={t('PlaceholderPlaceholder')}
            value={props.placeholder}
            onChange={(e) =>
              setProp((p: FormTextInputProps) => {
                p.placeholder = e.target.value || undefined;
              }, 500)
            }
          />
        </ControlsGroup>
      )}
      {hasSection<TextFieldPanelSection>(sections, 'Decimal') && (
        <ControlsGroup
          header={t('Decimal')}
          collapsible={true}
          contentClassName={Style.flexContainer}
          expanded={props.decimal !== undefined}
          onOpen={() => {
            setProp((prop: FormTextInputProps) => {
              prop.decimal = 0;
            }, 500);
          }}
          onClose={() => {
            setProp((prop: FormTextInputProps) => {
              prop.decimal = undefined;
            }, 500);
          }}
        >
          <SettingsInput
            type={'number'}
            value={props.decimal}
            onChange={(e) =>
              setProp((p: FormTextInputProps) => {
                p.decimal = e.target.value === undefined ? undefined : Number(e.target.value);
              }, 500)
            }
          />
        </ControlsGroup>
      )}
      {hasSection<TextFieldPanelSection>(sections, 'Units') && (
        <ControlsGroup
          header={t('Units')}
          collapsible={true}
          contentClassName={Style.flexContainer}
          expanded={!!props.units}
          onOpen={() => {
            setProp((prop: FormTextInputProps) => {
              prop.units = t('Units');
            }, 500);
          }}
          onClose={() => {
            setProp((prop: FormTextInputProps) => {
              prop.units = undefined;
            }, 500);
          }}
        >
          <SettingsInput
            placeholder={t('UnitsPlaceholder')}
            multiple={true}
            value={props.units}
            onChange={(e) =>
              setProp((p: FormTextInputProps) => {
                p.units = e.target.value || undefined;
              }, 500)
            }
          />
        </ControlsGroup>
      )}
    </PanelContainer>
  );
};
